module.exports = __webpack_public_path__ + "assets/shield.8c6258ae.svg";